import {gsap} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const isMobile = window.matchMedia("(max-width: 767px)").matches;
const duration = isMobile ? 0 : 1;
const illustration = document.querySelector('[data-illustration]')


if (illustration && illustration.dataset.illustration === 'stair-nosing') {
  function animateNosing(elementId, duration) {
    gsap.to(elementId, {
      duration: duration,
      x: -80,
      ease: "power2.inOut",
      scrollTrigger: {
        trigger: ".stair-nosing-animation",
        start: "bottom 100%",
        toggleActions: "play none none none",
      },
      onComplete: function() {
        gsap.to(".stair-nosing-animation__item", {
          duration: duration,
          opacity: 1
        });
      }
    });
  }

  setTimeout(() => {
    animateNosing("#first-nosing", duration);
    animateNosing("#second-nosing", duration);
  }, 1000)
}

if (illustration && illustration.dataset.illustration === 'production') {
  const tabs = illustration.querySelectorAll('div[data-tab]')

  function animateBoardProfile(elementId, duration, y) {
    gsap.to(elementId, {
      duration: duration,
      y,
      ease: "power2.inOut",
      scrollTrigger: {
        trigger: ".board-profile-animation",
        toggleActions: "play none none none"
      },
      onComplete: function() {
        gsap.to(".board-profile-animation__item", {
          duration: duration,
          opacity: 1
        });
      }
    });
  }

  tabs.forEach(tab => tab.addEventListener('tab:open', () => {
    gsap.killTweensOf("#first-board");
    gsap.killTweensOf("#second-board");
    gsap.killTweensOf("#third-board");
    gsap.killTweensOf(".board-profile-animation__item");
    gsap.set("#first-board", { y: 0, opacity: 1 });
    gsap.set("#second-board", { y: 0, opacity: 1 });
    gsap.set("#third-board", { y: 0, opacity: 1 });
    gsap.set(".board-profile-animation__item", { opacity: 0 });

    animateBoardProfile("#first-board", duration, -70);
    animateBoardProfile("#second-board", duration, -35);
    animateBoardProfile("#third-board", duration, 35);
  }))

  animateBoardProfile("#first-board", duration, -70);
  animateBoardProfile("#second-board", duration, -35);
  animateBoardProfile("#third-board", duration, 35);
}




